module.exports = __webpack_public_path__ + "static/media/MD_map@2x.65a6fbd0.png";